(function () {
    'use strict';
    app.service('adminTeamManagementService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getTeamData = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/teamList", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getTeamDataReport = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/teamReport", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getTeamAdminData = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getTeamAdmins", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getTeamMemberData = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getTeamMembers", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.saveAdminUpdatedTeamProfile = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/updateTeamProfile", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getTeamDetailsByTeamID = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/super/getTeamByID?eSpectraTeamPartyID=" + data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();